import { PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../../models/UserState";
import { EmailSendPayload } from "../../payload/EmailSendPayload";

const forgotPasswordFetch = (state: UserState, action: PayloadAction<EmailSendPayload>) => {
    state.isLoading = true;
}

export default forgotPasswordFetch;